import ProposalCardFooter from './ProposalCardFooter';
export default ProposalCardFooter;
